import { Tooltip } from "@/components/ui/tooltip";
import { LegalOnboardingListItem } from "@/services/legal-onboarding.service";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";

interface Props {
  item: LegalOnboardingListItem;
  handleDetail: (id: number) => void;
}

export const LegalOnboardingActions = ({
  handleDetail,
  item,
}: Props) => {
  //Acciones para contrato futuro
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver detalle</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <Eye
          cursor="pointer"
          onClick={() => handleDetail(item.id)}
          data-testid="slot-request-actions-eye"
        />
      </Flex>
    </Tooltip>
  );
};
